import { useTheme } from "@mui/material/styles";

interface WechatpayIconProps {
  width?: number;
  height?: number;
}

export default function WechatPayIcon({ width = 24, height = 24 }: WechatpayIconProps) {
  const theme = useTheme();
  const fillColor = theme.palette.mode === "dark" ? "#F2F2F2" : "#2D3135";

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path 
        d="M9.27001 14.6689C8.95222 14.8312 8.56305 14.7122 8.39034 14.4L8.34672 14.3054L6.52921 10.3069C6.52171 10.2588 6.52171 10.2097 6.52921 10.1615C6.52919 10.0735 6.56466 9.98916 6.62759 9.9276C6.69052 9.86603 6.77562 9.83243 6.86364 9.83438C6.93469 9.83269 7.0041 9.85582 7.05993 9.89981L9.24093 11.4265C9.40231 11.5346 9.59195 11.5928 9.78618 11.5937C9.90326 11.5945 10.0193 11.5723 10.1279 11.5283L20.175 7.02816C18.09 4.72544 15.1093 3.43931 12.0035 3.5022C6.47832 3.5022 2 7.23172 2 11.87C2.06583 14.4052 3.35548 16.7515 5.46052 18.1658C5.68682 18.3326 5.78304 18.6241 5.70043 18.8928L5.24969 20.594C5.22238 20.6714 5.20527 20.7521 5.1988 20.8339C5.19679 20.9232 5.23138 21.0094 5.29454 21.0726C5.3577 21.1358 5.44393 21.1703 5.53322 21.1684C5.6 21.1645 5.66485 21.1445 5.72224 21.1102L7.90325 19.8452C8.06285 19.7467 8.24642 19.6939 8.43396 19.6925C8.53254 19.6923 8.63059 19.707 8.72476 19.7361C9.78683 20.0363 10.8853 20.188 11.989 20.1869C17.5142 20.1869 22 16.4574 22 11.8554C22.0098 10.4834 21.6291 9.13687 20.902 7.97326L9.34998 14.6253L9.27001 14.6689Z" 
        fill={fillColor}
      />
    </svg>
  );
}

